import React from 'react';
import styled from '@emotion/styled';
import Button from '~/Components/Button';
import { useI18n } from '~Hooks';

const Wrapper = styled.div``;

const InfoText = styled.p`
  max-width: 336px;
  margin: 0 auto 32px;
  font-size: 24px;
  font-weight: 600;
  color: #545960;
`;

interface Props {
  showCreateView: () => void;
}

const TextBlock: React.FunctionComponent<Props> = ({ showCreateView }) => {
  const { i18n } = useI18n();

  return (
    <Wrapper>
      <InfoText>{i18n('Inventory.CreateNewText')}</InfoText>

      <Button
        background="#1642be"
        handleClick={showCreateView}
        text={i18n('Inventory.CreateNew')}
      />
    </Wrapper>
  );
};

export default TextBlock;
